import React from 'react'
import Joyride from 'react-joyride'
import '@styles/react/libs/joyride-tour/joyride-tour.scss'

const Tour = (props) => {
  return (
    <>
      <Joyride {...props} />
    </>
  )
}

export default Tour
